import { c as _c } from "react/compiler-runtime";
import { cloneElement, isValidElement, useState, type ReactNode } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuPortal, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { FilterMenuList } from "../FilterMenuList/FilterMenuList";
import { useDesktopFilters } from "../FilterOrchestrator/DesktopFilterOrchestrator/useDesktopFilters";
type ComputedFilters = ReturnType<typeof useDesktopFilters>["filtersWithComputedValues"];
type Props = {
  trigger: ReactNode;
  align: "start" | "end";
  filters: ComputedFilters;
};

/**
 * The "add filter" dropdown — a trigger that opens the list of available
 * filters. Reused by the toolbar button and the "+" in the active-filter bar.
 */
export function FilterMenu(t0) {
  const $ = _c(14);
  const {
    trigger,
    align,
    filters
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== trigger) {
    t1 = <DropdownMenuTrigger asChild={true} data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="FilterMenu.tsx">{trigger}</DropdownMenuTrigger>;
    $[0] = trigger;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== filters) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = (filter, index) => <DropdownMenuSub key={index}><DropdownMenuSubTrigger>{filter.title}</DropdownMenuSubTrigger><DropdownMenuPortal><DropdownMenuSubContent sideOffset={6} className={filter.customContent ? "p-0" : ""} {...filter.customContent ? {
            onOpenAutoFocus: _temp
          } : {}} {...filter.keepOpenOnInteract ? {
            onCloseAutoFocus: _temp2,
            onFocusOutside: _temp3
          } : {}}>{filter.customContent ? isValidElement(filter.customContent) ? cloneElement(filter.customContent as React.ReactElement<any>, {
              onClose: () => setOpen(false)
            }) : filter.customContent : <FilterMenuList activeValues={filter.activeValues} inactiveValues={filter.inactiveValues} onChange={filter.onChange} />}</DropdownMenuSubContent></DropdownMenuPortal></DropdownMenuSub>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = filters.map(t3);
    $[2] = filters;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <DropdownMenuGroup data-sentry-element="DropdownMenuGroup" data-sentry-source-file="FilterMenu.tsx">{t2}</DropdownMenuGroup>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== align || $[8] !== t3) {
    t4 = <DropdownMenuContent className="w-56" align={align} data-sentry-element="DropdownMenuContent" data-sentry-source-file="FilterMenu.tsx">{t3}</DropdownMenuContent>;
    $[7] = align;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== open || $[11] !== t1 || $[12] !== t4) {
    t5 = <DropdownMenu open={open} onOpenChange={setOpen} data-sentry-element="DropdownMenu" data-sentry-component="FilterMenu" data-sentry-source-file="FilterMenu.tsx">{t1}{t4}</DropdownMenu>;
    $[10] = open;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp3(e_1) {
  return e_1.preventDefault();
}
function _temp2(e_0) {
  return e_0.preventDefault();
}
function _temp(e) {
  return e.preventDefault();
}